import {registerDecorator, ValidationArguments, ValidationOptions} from 'class-validator';
import {checkUrlAvailability} from "../../api/userProfileService";

export function FoundMatchingURL(validationOptions?: ValidationOptions) {
    return function (object: Object, propertyName: string) {
        registerDecorator({
            name: 'foundMatchingURL',
            target: object.constructor,
            propertyName: propertyName,
            options: validationOptions,
            validator: {
                async validate(value: any, args: ValidationArguments) {
                    try{
                        return await checkUrlAvailability(value);
                    } catch (e) {
                        return false;
                    }
                },
            },
        });
    };
}